import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Mitra = () => {
  const { isDarkMode } = useDarkMode();

  const partners = [
    { name: 'Indosat Ooredoo', logo: '/image/logo_mitra/mitra/indosat.svg' },
    { name: 'PGN COM', logo: '/image/logo_mitra/mitra/PGN COM always reliable.svg' },
    { name: 'Icon+', logo: '/image/logo_mitra/mitra/Icon+.png' },
    { name: 'PT Mora Telematika', logo: '/image/logo_mitra/mitra/PT Mora Telematika Indonesia Tbk.png' },
    { name: 'Bank Aceh', logo: '/image/logo_mitra/mitra/bank_aceh.png' },
    { name: 'PT Informatika Perkasa', logo: '/image/logo_mitra/mitra/PT Informatika Perkasa Abadi.png' },
    { name: 'Reyeee Network', logo: '/image/logo_mitra/mitra/Reyeee Network.png' },
    { name: 'Mikrotik', logo: '/image/logo_mitra/mitra/Mikrotik.svg' },
    { name: 'Ubiquiti', logo: '/image/logo_mitra/mitra/Ubiquiti Networks.png' },
    { name: 'Acer', logo: '/image/logo_mitra/mitra/Acer.svg' },
    { name: 'ZTE', logo: '/image/logo_mitra/mitra/ZTE Corporation.png' },
    { name: 'Data', logo: '/image/logo_mitra/mitra/Data.png' },
    { name: 'Xiaomi', logo: '/image/logo_mitra/mitra/Xiaomi.png' },
    { name: 'HIKVISION', logo: '/image/logo_mitra/mitra/HIKVISION.png' },
    { name: 'HUAWEI', logo: '/image/logo_mitra/mitra/huawaei.svg' },
  ];

  const clients = [
    { name: 'Pertamina', logo: '/image/logo_mitra/client/Pertamina.svg' },
    { name: 'LAN RI', logo: '/image/logo_mitra/client/Lembaga Administrasi Negara Republik Indonesia.png' },
    { name: 'PT Adhi Karya', logo: '/image/logo_mitra/client/Adhi Karya.png' },
    { name: 'Pemkab Aceh Barat', logo: '/image/logo_mitra/client/Pemerintah Kabupaten Aceh Barat.png' },
    { name: 'Kemenkes BBKK', logo: '/image/logo_mitra/client/Kemenkes BBKK Medan.png' },
    { name: 'UTU', logo: '/image/logo_mitra/client/Universitas Teuku Umar.png' },
    { name: 'UNMUHA', logo: '/image/logo_mitra/client/Universitas Muhammadiyah Aceh.png' },
    { name: 'USM', logo: '/image/logo_mitra/client/Universitas Serambi Mekkah.png' },
    { name: 'STAIN Meulaboh', logo: '/image/logo_mitra/client/STAIN Teungku Dirundeng Meulaboh.png' },
    { name: 'Parkside Hotels', logo: '/image/logo_mitra/client/Parkside Hotels Indonesia.png' },
    { name: 'UNSAM', logo: '/image/logo_mitra/client/Universitas_Samudra.png' },
    { name: 'Portola Hotel', logo: '/image/logo_mitra/client/Portola Grand Arabia Hotel.png' },
    { name: 'Hermens Palace', logo: '/image/logo_mitra/client/Hermens Palace Hotel.png' },
    { name: 'PT AJB', logo: '/image/logo_mitra/client/PT Agrabudi Jasa Bersama (AJB).png' },
    { name: 'PT Bara Energi', logo: '/image/logo_mitra/client/PT Bara Energi.png' },
    { name: 'PT PPA', logo: '/image/logo_mitra/client/PT PPA.png' },
    { name: 'APPJI', logo: '/image/logo_mitra/client/APPJI.png' },
    { name: 'PT Mifa', logo: '/image/logo_mitra/client/PT Mifa Bersaudara.svg' },
    { name: 'RSU Cut Nyak Dhien', logo: '/image/logo_mitra/client/RUMAH SAKIT UMUM CUT NYAK DHIEN.png' },
    { name: 'RS Cempaka Lima', logo: '/image/logo_mitra/client/Rumah Sakit Umum Cempaka Lima.png' },
    { name: 'HIGH SPEED', logo: '/image/logo_mitra/client/HIGH SPEED INTERNET POWERFULL.gif' },
    { name: 'PT AGRO SINERGI', logo: '/image/logo_mitra/client/PT AGRO SINERGI NUSANTARA.png' },
    { name: 'TIRTA NUSA', logo: '/image/logo_mitra/client/TIRTA NUSA BUANA.png' },
    { name: 'PT Iweka', logo: '/image/logo_mitra/client/PT Iweka Digital Solusi.png' },
    { name: 'PT WARGI', logo: '/image/logo_mitra/client/PT WARGI SANTOSO.png' },
  ];

  const LogoMarquee = ({ items, speed = 30 }) => {
    const doubled = [...items, ...items];
    return (
      <div className="overflow-hidden">
        <div className="flex animate-marquee items-center" style={{ animationDuration: `${speed}s` }}>
          {doubled.map((item, idx) => (
            <div key={idx} className="flex-shrink-0 mx-6" title={item.name}>
              <img
                src={item.logo}
                alt={item.name}
                className="h-10 md:h-12 object-contain grayscale hover:grayscale-0 transition duration-300 opacity-70 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={`${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'} py-16`}>
      <div className="section-container">
        {/* Mitra */}
        <div className="text-center mb-8">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Mitra</h2>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Bekerja sama dengan mitra perusahaan ternama.
          </p>
        </div>
        <LogoMarquee items={partners} speed={25} />

        {/* Client */}
        <div className="text-center mt-14 mb-8">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Client</h2>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Dipercaya oleh berbagai client dalam menyediakan konektivitas bisnis yang andal.
          </p>
        </div>
        <LogoMarquee items={clients} speed={40} />
      </div>
    </div>
  );
};

export default Mitra;
